var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mt-4 box-users" }, [
      _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
        _c("h5", [_vm._v("Usuarios de la empresa")]),
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-end" },
          [
            _c("b-form-input", {
              staticClass: "d-inline-block mr-1",
              attrs: { placeholder: "Filtrar...", "data-cy": "search-user" },
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        )
      ]),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "col-md-6 border-right" },
        [
          _c(
            "vs-list",
            { staticClass: "box-users" },
            _vm._l(_vm.filteredUsers, function(user) {
              return _c(
                "div",
                { key: user.id },
                [
                  _c(
                    "vs-list-item",
                    {
                      class: { exists: _vm.isUserInGroup(user) },
                      attrs: { title: user.nombre, subtitle: user.correo }
                    },
                    [
                      !_vm.isUserInGroup(user)
                        ? _c(
                            "vs-button",
                            {
                              attrs: {
                                color: "warning",
                                size: "small",
                                type: "border",
                                "data-cy": "add-permission"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addUser(user)
                                }
                              }
                            },
                            [_vm._v(" Agregar ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c(
            "vs-list",
            { staticClass: "box-users" },
            _vm._l(_vm.selectedUsers, function(user) {
              return _c(
                "div",
                { key: user.id, attrs: { "data-cy": "remove-permission" } },
                [
                  _c(
                    "vs-list-item",
                    { attrs: { title: user.nombre, subtitle: user.correo } },
                    [
                      _c("vs-button", {
                        attrs: {
                          color: "danger",
                          size: "small",
                          type: "border",
                          icon: "highlight_off",
                          "data-cy": "remove-permission"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeUser(user)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "mt-4 p-3 border rounded bg-light" },
      [
        _vm._m(1),
        _c("b-form-radio-group", {
          attrs: {
            options: _vm.reemplazarOptions,
            name: "reemplazar-perfiles",
            stacked: ""
          },
          model: {
            value: _vm.reemplazar,
            callback: function($$v) {
              _vm.reemplazar = $$v
            },
            expression: "reemplazar"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-4 text-right" },
      [
        _c(
          "b-button",
          { attrs: { variant: "primary" }, on: { click: _vm.saveChanges } },
          [_vm._v(" Guardar cambios ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Usuarios que recibirán los perfiles")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "mb-3" }, [
      _c("i", { staticClass: "feather icon-settings mr-2" }),
      _vm._v(" Configuración de copia ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }